import React from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
//https://github.com/wojtekmaj/react-daterange-picker

import './DateRangePickerWithCalendar.css';

const DateRangePickerWithCalendar = (props) => {
  return(
    <>
    {props.authed ? 
      <DateRangePicker
        onChange={props.onChange}
        value={props.value}
        maxDate={new Date()}
        minDate={props.minDate}
        minDetail="decade"
        format="y-MM-dd"
        clearIcon={null}
      />
      :<DateRangePicker
        onChange={props.onChange}
        value={props.value}
        maxDate={new Date()}
        minDate={props.minDate}
        minDetail="decade"
        format="y-MM-dd"
        clearIcon={null}
        disabled={true}
      />}
    </>
  )
}

export default DateRangePickerWithCalendar;